let routes = [
  {
    path: '/storage',
    name: 'storage',
    component: () => import('./components/StorageMain.vue')
  }
]

export default routes
